import React from 'react';

const CircularProgressSVG = () => (
  <svg width="20" height="20" viewBox="22 22 44 44" style={{ marginRight: 10 }}>
    <circle
      cx="44"
      cy="44"
      r="20.2"
      fill="none"
      stroke="#0AD172"
      strokeWidth="3.6"
      strokeLinecap="round"
      strokeDasharray="186"
      strokeDashoffset="100"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 44 44"
        to="360 44 44"
        dur="1s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);

export default CircularProgressSVG;



// WEBPACK FOOTER //
// ./src/features/score-card/components/upload-single-batch-user-form/AsyncSelect/CircularProgressSVG.jsx